import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from 'src/app/core/objects/user';
import { PaymentApiService } from 'src/app/core/services/payment-api.service';
import { UserService } from 'src/app/core/services/user.service';
import { ModalService } from 'src/app/modal/modal.service';
import { ProInfoComponent } from '../../../modal/components/pro-info/pro-info.component';

@Component({
    selector: 'gl-pro-icon',
    templateUrl: './pro-icon.component.html',
    styleUrls: ['./pro-icon.component.scss'],
    standalone: false
})
export class ProIconComponent implements OnDestroy {
  public user: User;
  private subscription: Subscription[] = [];

  constructor(
    private modalService: ModalService,
    private paymentApiService: PaymentApiService,
    private userService: UserService,
  ) {
    this.subscription.push(this.userService.user.subscribe((user: User) => (this.user = user)));
  }

  public ngOnDestroy(): void {
    this.subscription.forEach((s) => s.unsubscribe());
  }

  public openProInfoModal(e: MouseEvent): void {
    e.stopPropagation();
    e.preventDefault();
    this.paymentApiService
      .getPayment(this.user?.company?.country)
      .subscribe(() => this.modalService.open(ProInfoComponent).subscribe());
  }
}
